import api from "./api";

export const getExceptionList = async (queryParam) => {
  return api
    .get({
      endpoint: "/exception-time-booking",
      port: process.env.REACT_APP_PORT_OPENHOUR,
      queryParam,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
